
import { defineComponent } from 'vue'

export default defineComponent({
    name: "Bot",
    data() {
        return {}
    }
})
